import { Localization } from "material-table";

const localization: Localization = {
  header: {
    actions: "",
  },
};

export default localization;
